const LOCAL_NOT_SHOW_NEW_OPERATION_ALERT = "__di_not_show_new_operation_alert";
const LOCAL_TRANSACTION_TYPE  = "__di_dashboard_transaction_type";
const LOCAL_USE_CURRENT_TIME  = "__di_dashboard_use_current_time";
const LOCAL_DASHBOARD_FILTERS = "__di_dashboard_filters"; //deprecato dalla 1.3.0
const LOCAL_LAST_VERSION = "__di_dashboard_last_version";
const LOCAL_DATA_FILTER = "__di_dashboard_data_filter";
const LOCAL_SHOW_VERSION_DOT = "__di_show_version_dot";
const LOCAL_MERCHANT_CODE = "__di__merchant_code";
const LOCAL_ACCESS_TOKEN = "__di__access_token";
const LOCAL_APP_TOKEN = "__di__app_token";
const LOCAL_USER_TYPE = "__di_user_type";

const LOCAL_WAITER_PRODUCTION_COLOR = "__di_waiterProductionColor";
const LOCAL_TOP_10_CATEGORIES_COLOR = "__di_top10CategoriesColor";
const LOCAL_SELLED_PRODUCT_COLOR = "__di_selledProductColor";
const LOCAL_TOP_10_PRODUCT_COLOR = "__di_top10ProductsColor";
const LOCAL_PAYMENT_METHOD_COLOR = "__di_paymentMethodColor";
const LOCAL_WAITER_EARN_COLOR = "__di_waiterEarnColor";
const LOCAL_BRANDS_COLOR = "__di_brandsColor";
const LOCAL_EARN_COLOR = "__di_earnColor";

const LOCAL_FAST_EARN_COMPARE_1 = "__di_fast_earn_compare_1";
const LOCAL_FAST_EARN_COMPARE_2 = "__di_fast_earn_compare_2";
const LOCAL_FAST_EARN_COMPARE_3 = "__di_fast_earn_compare_3";

const LOCAL_FAST_CUSTOMER_COMPARE_1 = "__di_fast_customer_compare_1";
const LOCAL_FAST_CUSTOMER_COMPARE_2 = "__di_fast_customer_compare_2";
const LOCAL_FAST_CUSTOMER_COMPARE_3 = "__di_fast_customer_compare_3";

const LOCAL_FAST_RECEIPT_COMPARE_1 = "__di_fast_receipt_compare_1";
const LOCAL_FAST_RECEIPT_COMPARE_2 = "__di_fast_receipt_compare_2";
const LOCAL_FAST_RECEIPT_COMPARE_3 = "__di_fast_receipt_compare_3";

const LOCAL_FAST_AVERAGE_RECEIPT_COMPARE_1 = "__di_fast_average_receipt_compare_1";
const LOCAL_FAST_AVERAGE_RECEIPT_COMPARE_2 = "__di_fast_average_receipt_compare_2";
const LOCAL_FAST_AVERAGE_RECEIPT_COMPARE_3 = "__di_fast_average_receipt_compare_3";

const LOCAL_LAYOUT_FAST_STATS_RESTAURANT = "__di_layout_fast_stats_restaurant";
const LOCAL_LAYOUT_GRAPHICS_RESTAURANT = "__di_layout_graphics_restaurant";
const LOCAL_LAYOUT_TABLE_RESTAURANT = "__di_layout_table_restaurant";

const LOCAL_LAYOUT_FAST_STATS_RETAIL = "__di_layout_fast_stats_retail";
const LOCAL_LAYOUT_GRAPHICS_RETAIL = "__di_layout_graphics_retail";
const LOCAL_LAYOUT_TABLE_RETAIL = "__di_layout_table_retail";

const LOCAL_OPERATION_CREATE_FIRST_OPEN = "__di_operation_create_first_open";
const LOCAL_AUDIENCE_CREATE_FIRST_OPEN = "__di_audience_create_first_open";
const LOCAL_OPERATION_FIRST_OPEN = "__di_operation_first_open";
const LOCAL_AUDIENCE_FIRST_OPEN = "__di_audience_first_open";

const LOCAL_OPERATION_NOTIFICATION_FIRST_OPEN = "__di_operation_notification_first_open";
const LOCAL_OPERATION_COUPON_FIRST_OPEN = "__di_operation_coupon_first_open";

const LOCAL_DARK_MODE = "__di_dark_mode";

const LIGHT_MOBILE_HEADER = "rgb(255 255 255 / 53%)";
const DARK_MOBILE_HEADER = "rgb(41 41 41 / 53%)";
const DARK_BG_CONTAINER = "#13131370";
const LIGHT_BG_CONTAINER = "#ffffff";
const PRIMARY_COLOR = "#008833";
const COMPARE_GREEN = "#3f8600";
const DARK_BG_BODY = "#161515";
const COMPARE_RED = "#cf1322";
const DARK_TEXT = "#000";

const TOOLTIP_DIFF_TEXT = "Indica il giorno precedente da cui attingere i dati";
const TAG_BORDER = false;

const REGEX_ONLY_LETTERS = /^[A-Za-z]+$/;
const REGEX_HTTPS = /^https:\/\/.+/;

// ------------ NOMI DEI FILTRI ------------
const FILTERS_NAME = [
   "waitersProduction",
   "selledCategories",
   "top10Categories",
   "selledProduct",
   "top10Products",
   "paymentMethod",
   "openedTable",
   "receiptData",
   "brands",
   "earn",
];
// ------------ nomi di ogni widget di statistica che viene visualizzato o meno a seconda dei filtri, e la configurazione viene salvata nel local storage.
// ------------ Se non sono salvati, vengono inizializzati questi (lista completa per vederli tutti)
// ------------ NOMI DEI FILTRI ------------

const TAG_COLORS_PALETTE = [
   "geekblue",
   "magenta",
   "volcano",
   "purple",
   "orange",
   "green",
   "gold",
   "lime",
   "cyan",
   "blue",
   "red",
];

// ------------ LAYOUT DELLE PAGINE CONFIGURABILI ------------

// ------------ API ENDPOINTS ------------

const X_API_KEY = "gq7LJ6x6wAnYjDYFxmr6UjfQ3qSAluoFiWbo2YLasgBPKOOMblEmaXgsKNHYIbU27TiqkNth3mJXjLChdV5zK8xLmen77IvaeXdOZcJpm6puedJvwWFSEnqhtVv7GHUN";
const ENDPOINT_BASE_PATH = "rest_gate/sales";

const ENDPOINT_CORRECTION_LIST = `${ENDPOINT_BASE_PATH}/correction_list`;
const ENDPOINT_BACCO_DOC_TYPE = `${ENDPOINT_BASE_PATH}/bacco_doc_type`;
const ENDPOINT_PAYMENTS_DATA = `${ENDPOINT_BASE_PATH}/payments_data`;
const ENDPOINT_MOVEMENT_TYPE = `${ENDPOINT_BASE_PATH}/movement_type`;
const ENDPOINT_PAYMENTS_LIST = `${ENDPOINT_BASE_PATH}/payments_list`;
const ENDPOINT_PERIOD_SALES = `${ENDPOINT_BASE_PATH}/period_sales`;
const ENDPOINT_WAITER_LIST = `${ENDPOINT_BASE_PATH}/waiter_list`;
const ENDPOINT_CANCELLED = `${ENDPOINT_BASE_PATH}/get_cancelled`;
const ENDPOINT_SOLD_ITEMS = `${ENDPOINT_BASE_PATH}/sold_items`;
const ENDPOINT_TIME_SLOTS = `${ENDPOINT_BASE_PATH}/time_slots`;
const ENDPOINT_DOC_TYPE = `${ENDPOINT_BASE_PATH}/doc_type`;
const ENDPOINT_BRANDS = `${ENDPOINT_BASE_PATH}/brands`;
const ENDPOINT_SHOPS = `${ENDPOINT_BASE_PATH}/shops`;

const ENDPOINT_MARKETING_BASE_PATH = "https://mktselettivo-416914793312.europe-west8.run.app/api/v1";
//const ENDPOINT_MARKETING_BASE_PATH = "http://192.168.1.150:3000/api/v1";

const ENDPOINT_MARKETING_GET_USERS_LIST_MANUAL = "get/potential-audience-user-list-manual";
const ENDPOINT_MARKETING_GET_POTENTIAL_AUDIENCE = "get/potential-audience-live";
const ENDPOINT_MARKETING_GET_AUDIENCE_USERS = "get/potential-audience-by-id";
const ENDPOINT_MARKETING_GET_USERS_LIST = "get/potential-audience-user-list";
const ENDPOINT_MARKETING_DELETE_AUDIENCE = "delete/audience";
const ENDPOINT_MARKETING_UPDATE_AUDIENCE = "update/audience";
const ENDPOINT_MARKETING_SET_AUDIENCE = "set/audience";
const ENDPOINT_MARKETING_GET_AUDIENCE = "get/audience";

const ENDPOINT_MARKETING_UPDATE_OPERATION = "update/operation";
const ENDPOINT_MARKETING_DELETE_OPERATION = "delete/operation";
const ENDPOINT_MARKETING_GET_OPERATIONS = "get/operations";
const ENDPOINT_MARKETING_SET_OPERATION = "set/operation";

const ENDPOINT_MARKETING_APP_ACTIVITIES = "channels/push/easyappear/get/pages/activities";
const ENDPOINT_MARKETING_APP_CAMPAIGNS = "channels/push/easyappear/get/pages/campaigns";
const ENDPOINT_MARKETING_APP_COUPONS = "channels/push/easyappear/get/pages/coupons";
const ENDPOINT_MARKETING_APP_PAGES = "channels/push/easyappear/get/pages";

// ------------ API ENDPOINTS ------------


const DEBUG_MODE = false;

export {
   LOCAL_NOT_SHOW_NEW_OPERATION_ALERT,
   LOCAL_TOP_10_CATEGORIES_COLOR,
   LOCAL_WAITER_PRODUCTION_COLOR,
   LOCAL_PAYMENT_METHOD_COLOR,
   LOCAL_TOP_10_PRODUCT_COLOR,
   LOCAL_SELLED_PRODUCT_COLOR,
   LOCAL_WAITER_EARN_COLOR,
   LOCAL_SHOW_VERSION_DOT,
   LOCAL_BRANDS_COLOR,
   LOCAL_EARN_COLOR,
   
   LOCAL_LAYOUT_FAST_STATS_RESTAURANT,
   LOCAL_LAYOUT_GRAPHICS_RESTAURANT,
   LOCAL_LAYOUT_TABLE_RESTAURANT,

   LOCAL_LAYOUT_FAST_STATS_RETAIL,
   LOCAL_LAYOUT_GRAPHICS_RETAIL,
   LOCAL_LAYOUT_TABLE_RETAIL,

   REGEX_ONLY_LETTERS,
   REGEX_HTTPS,
   TAG_BORDER,
   
   LOCAL_DASHBOARD_FILTERS,
   LOCAL_USE_CURRENT_TIME,
   LOCAL_TRANSACTION_TYPE,
   LOCAL_MERCHANT_CODE,
   LOCAL_ACCESS_TOKEN,
   LOCAL_LAST_VERSION,
   LOCAL_DATA_FILTER,
   LOCAL_USER_TYPE,
   LOCAL_APP_TOKEN,

   LOCAL_FAST_EARN_COMPARE_1,
   LOCAL_FAST_EARN_COMPARE_2,
   LOCAL_FAST_EARN_COMPARE_3,

   LOCAL_FAST_CUSTOMER_COMPARE_1,
   LOCAL_FAST_CUSTOMER_COMPARE_2,
   LOCAL_FAST_CUSTOMER_COMPARE_3,

   LOCAL_FAST_RECEIPT_COMPARE_1,
   LOCAL_FAST_RECEIPT_COMPARE_2,
   LOCAL_FAST_RECEIPT_COMPARE_3,

   LOCAL_FAST_AVERAGE_RECEIPT_COMPARE_1,
   LOCAL_FAST_AVERAGE_RECEIPT_COMPARE_2,
   LOCAL_FAST_AVERAGE_RECEIPT_COMPARE_3,

   LOCAL_OPERATION_CREATE_FIRST_OPEN,
   LOCAL_AUDIENCE_CREATE_FIRST_OPEN,

   LOCAL_OPERATION_NOTIFICATION_FIRST_OPEN,
   LOCAL_OPERATION_COUPON_FIRST_OPEN,
   
   LOCAL_OPERATION_FIRST_OPEN,
   LOCAL_AUDIENCE_FIRST_OPEN,

   X_API_KEY,

   ENDPOINT_MARKETING_APP_ACTIVITIES,
   ENDPOINT_MARKETING_APP_CAMPAIGNS,
   ENDPOINT_MARKETING_APP_COUPONS,
   ENDPOINT_MARKETING_APP_PAGES,
   
   ENDPOINT_MARKETING_UPDATE_OPERATION,
   ENDPOINT_MARKETING_DELETE_OPERATION,
   ENDPOINT_MARKETING_GET_OPERATIONS,
   ENDPOINT_MARKETING_SET_OPERATION,

   ENDPOINT_MARKETING_GET_POTENTIAL_AUDIENCE,
   ENDPOINT_MARKETING_GET_USERS_LIST_MANUAL,
   ENDPOINT_MARKETING_GET_AUDIENCE_USERS,
   ENDPOINT_MARKETING_UPDATE_AUDIENCE,
   ENDPOINT_MARKETING_DELETE_AUDIENCE,
   ENDPOINT_MARKETING_GET_USERS_LIST,
   ENDPOINT_MARKETING_GET_AUDIENCE,
   ENDPOINT_MARKETING_SET_AUDIENCE,
   ENDPOINT_MARKETING_BASE_PATH,
   
   ENDPOINT_CORRECTION_LIST,
   ENDPOINT_BACCO_DOC_TYPE,
   ENDPOINT_PAYMENTS_DATA,
   ENDPOINT_MOVEMENT_TYPE,
   ENDPOINT_PAYMENTS_LIST,
   ENDPOINT_PERIOD_SALES,
   ENDPOINT_WAITER_LIST,  
   ENDPOINT_SOLD_ITEMS,
   ENDPOINT_TIME_SLOTS, 
   ENDPOINT_CANCELLED,
   ENDPOINT_DOC_TYPE,
   ENDPOINT_BRANDS,
   ENDPOINT_SHOPS, 

   LOCAL_DARK_MODE,
   
   LIGHT_MOBILE_HEADER,
   DARK_MOBILE_HEADER,
   LIGHT_BG_CONTAINER,
   DARK_BG_CONTAINER,
   COMPARE_GREEN,
   PRIMARY_COLOR,
   DARK_BG_BODY,
   COMPARE_RED,
   DARK_TEXT,

   TAG_COLORS_PALETTE,
   FILTERS_NAME,

   TOOLTIP_DIFF_TEXT,

   DEBUG_MODE,
}